export default function isLabelStackUnderSegment(labelStack, segmentId) {
  return labelStack.some(function (label) {
    return 'segmentId' in label && label.segmentId === segmentId;
  });
}